import React from "react";
/*import { graphql } from "react-apollo";
import gql from "graphql-tag";*/
import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";
import Button from "./Button";
import styled from "styled-components";
import moment from "moment-timezone";

moment.tz.setDefault("Europe/Luxembourg");
moment.locale("fr");

const NotficationContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
`;
const From = styled.p`
  font-size: 1em;
  font-weight: bolder;
  color: #000;
  text-align: left;
  order: 0;
  flex: 0 1 auto;
  align-self: stretch;
`;
const To = styled.p`
  font-size: 1em;
  font-weight: bolder;
  color: #000;
  text-align: left;
  order: 0;
  flex: 0 1 auto;
  align-self: stretch;
`;
const Date = styled.span`
  font-size: 0.8em;
  color: #999;
  float: right;
`;
const MessageText = styled.p`
  color: #333;
  order: 0;
  width: 100%;
  flex: 0 1 auto;
  align-self: auto;
  padding: 0.2rem;
  background-color: #f6f5f3;
  white-space: pre-wrap;
`;

const ReplyText = styled.p`
  color: #999;
  order: 0;
  font-style: italic;
  width: 100%;
  flex: 0 1 auto;
  align-self: auto;
  padding: 0.2rem;
  background-color: #f6f5f3;
  border-bottom: 1px solid #d0d0d0;
  white-space: pre-wrap;
`;

const ButtonContainer = styled.div`
  /*display: flex;
  justify-content: space-between;*/
  order: 0;
  flex: 0 1 auto;
  align-self: center;
`;

class MessageNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, reply: "", emailSent: false };
  }

  updateToast = () => {
    //  this.setState({ autoCloseOn: true }, () => this.props.updateToast());
  };

  handleClose = () => {
    this.props
      .updateMessageMutation({
        variables: { id: this.props.message.id, status: "CLOSED" }
      })
      .then(() => {
        this.props.closeToast();
      });
  };
  reply = () => {
    //TODO id might be there twice, filter and map
    let toIds = this.props.message.to.filter(u => {
      return u.id !== this.props.userId;
    });
    toIds = toIds.map(u => u.id);
    toIds.push(this.props.message.from.id);

    /***/
    this.setState({ loading: true });
    this.props.updateMessageMutation({
      variables: { id: this.props.message.id, status: "REPLIED" }
    });
    this.props
      .createMessageMutation({
        variables: {
          text: this.state.reply, //.replace(/<br\s*[\/]?>/gi, "\n"),
          fromId: this.props.userId,
          toIds: toIds,
          replyId: this.props.message.id
        }
      })
      .then(ret => {
        this.props.closeToast();
      })
      .catch(e => {
        console.error(e);
        this.setState({
          error: true,
          loading: false
        });
      });
  };

  onEnterPress = e => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      this.reply();
    }
  };

  sendMailto = () => {
    let email = this.props.email; //littletower@gmail.com";
    let sender = this.props.message.from.name;
    let message = this.props.message.text; //.replace(/&nbsp;/g, " ");
    let patientPrenom = this.props.message.patient
      ? this.props.message.patient.prenom
      : "";
    let patientNom = this.props.message.patient
      ? this.props.message.patient.nom
      : "";
    let patientMatricule = this.props.message.patient
      ? this.props.message.patient.matricule
      : "";
    let date = moment(this.props.message.createdAt).format("HH:mm DD/MM/YYYY");
    this.setState({ loading: true });

    this.props
      .sendMailto({
        variables: {
          email,
          date,
          sender,
          message,
          patientPrenom,
          patientNom,
          patientMatricule
        }
      })
      .then(data => {
        this.setState({ loading: false, emailSent: true });
        /*    this.props.updateMessageMutation({
          variables: { id: this.props.message.id, status: "CLOSED" }
        });*/
        //  this.props.closeToast();
        //console.log("email.sned");
      })
      .catch(e => {
        console.error("error sending email to " + email, e);
      });
  };

  handleReply = event => {
    this.setState({
      reply: event.target.value
    });
  };
  render() {
    const { message } = this.props;
    let messageText = message.text; //sanitizeHtml(message.text, sanitizeConf); //.replace(/&nbsp;/g, " ");
    let messageTextWithPatient = null;
    if (message.patient) {
      messageTextWithPatient = (
        <React.Fragment>
          <span
            className="patient-tag"
            onClick={() => this.props.openHistoryModal(message.patient.id)}
          >
            {message.patient.nom} {message.patient.prenom}
          </span>{" "}
          <div
            style={{ display: "inline" }}
            dangerouslySetInnerHTML={{ __html: message.text }}
          />
        </React.Fragment>
      );
    }
    let replyPatientSpan = null;
    if (message.reply) {
      replyPatientSpan = message.reply.patient
        ? `<span class="patient-tag">${message.reply.patient.nom} ${message
            .reply.patient.prenom}</span> `
        : "";
    }

    const to = message.to.map(re => re.name).join(", ");
    let messageReply = null;
    if (message.reply) {
      messageReply =
        message.reply.from.id === this.props.userId
          ? "Vous"
          : message.reply.from.name;
      messageReply += ": " + replyPatientSpan + message.reply.text;
    }
    return (
      <NotficationContainer>
        <From>
          De: {message.from.name}
          <Date>{moment(message.createdAt).format("HH:mm DD/MM/YYYY")}</Date>
        </From>
        {message.to.length > 1 ? <To>À: {to}</To> : null}
        {messageReply ? (
          <ReplyText
            className="quote-reply"
            dangerouslySetInnerHTML={{ __html: messageReply }}
          />
        ) : null}
        {messageTextWithPatient === null ? (
          <MessageText
            className="quote"
            dangerouslySetInnerHTML={{ __html: messageText }}
          />
        ) : (
          <MessageText className="quote">{messageTextWithPatient}</MessageText>
        )}

        {/*        <MessageText className="quote">
          d'Patienten froen ab winni dei nei Impfung rembourséiert get
        </MessageText>
        */}

        <textarea
          style={{ marginTop: "0.3rem" }}
          className="textarea"
          rows="1"
          onKeyDown={this.onEnterPress}
          placeholder="Votre réponse"
          value={this.state.reply}
          onChange={this.handleReply}
        />
        <ButtonContainer>
          <Button
            text="Fermer"
            onClick={this.handleClose}
            disabled={this.state.loading}
          />
          <Button
            color="#00893D"
            text="MailTo"
            onClick={this.sendMailto}
            disabled={this.state.loading || this.state.emailSent}
          />
          {message.to.length > 1 ? (
            <Button
              disabled={this.state.reply.length === 0 || this.state.loading}
              color="#00893D"
              text="Répondre à tous"
              onClick={this.reply}
              type="submit"
            />
          ) : (
            <Button
              disabled={this.state.reply.length === 0 || this.state.loading}
              color="#00893D"
              text="Répondre"
              onClick={this.reply}
              type="submit"
            />
          )}
        </ButtonContainer>
      </NotficationContainer>
    );
    /*
    return (
      <div>
        {this.state.loading ? (
          <div>
            <DateText>Le prochain rendez-vous disponible est le :</DateText>
            <figure className="image is-58x58" style={{ margin: "auto" }}>
              <img alt="loading" src={loading} />
            </figure>
          </div>
        ) : (
          <div>
            <DateText>Le prochain rendez-vous disponible est le :</DateText>
            <Date>05 juin 2018 à 16:45</Date>
            <ButtonContainer>
              <Button text="Retour" onClick={this.props.toggleModal} />
              <Button
                color="#00893D"
                text="Prendre"
                onClick={this.handleSave}
              />
            </ButtonContainer>
          </div>
        )}
      </div>
    );*/
  }
}
const UPDATE_MESSGE_MUTATION = gql`
  mutation UpdateMessageMutation($id: ID!, $status: MessageStatus!) {
    updateMessage(id: $id, status: $status) {
      id
    }
  }
`;
const UPDATE_MESSGE_REPLY_MUTATION = gql`
  mutation UpdateMessageReplyMutation(
    $id: ID!
    $replyText: String!
    $toIds: [ID!]!
    $fromId: ID!
  ) {
    updateMessage(
      id: $id
      status: REPLIED
      reply: { text: $replyText, fromId: $fromId, toIds: $toIds, status: NEW }
    ) {
      id
    }
  }
`;
const CREATE_MESSAGE_MUTATION = gql`
  mutation CreateMessageMutation(
    $toIds: [ID!]!
    $text: String!
    $fromId: ID!
    $replyId: ID!
  ) {
    createMessage(
      toIds: $toIds
      text: $text
      fromId: $fromId
      replyId: $replyId
    ) {
      id
    }
  }
`;

const SEND_MAILTO = gql`
  mutation SendMailtoMutation(
    $email: String!
    $date: String!
    $message: String!
    $sender: String!
    $patientNom: String
    $patientPrenom: String
    $patientMatricule: String
  ) {
    sendMailto(
      email: $email
      date: $date
      message: $message
      sender: $sender
      patientNom: $patientNom
      patientPrenom: $patientPrenom
      patientMatricule: $patientMatricule
    ) {
      success
    }
  }
`;

export default compose(
  graphql(UPDATE_MESSGE_MUTATION, {
    name: "updateMessageMutation"
  }),
  graphql(SEND_MAILTO, {
    name: "sendMailto"
  }),
  graphql(UPDATE_MESSGE_REPLY_MUTATION, {
    name: "updateMessageReplyMutation"
  }),
  graphql(CREATE_MESSAGE_MUTATION, {
    name: "createMessageMutation"
  })
)(MessageNotification);



// WEBPACK FOOTER //
// ./src/components/utilities/MessageNotification.js